export default __webpack_public_path__ + "static/media/013-Bid.0e840b66.svg";